<div class="content">
    <h2 data-qa="tnb-sub-header">Netzbetreiber</h2>

    <redispatch-netzbetreiber-list></redispatch-netzbetreiber-list>
</div>

